import React, { useState } from 'react'
import { Layout, Menu, Breadcrumb } from 'antd';
import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const MainView = (props) => {

  const [collapsed, setCollapsed] = useState(false)

  const onCollapse = () => {
    setCollapsed(!collapsed)
  }

  const logout = () => {
    alert('lougout')
  }

    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
          <div className="logo" style={{textAlign: 'center', fontSize: 20, fontWeight: 600}}>
            Conservational
          </div>
          <Menu theme="dark" mode="inline">
            <Menu.Item key="1" icon={<PieChartOutlined />}>
              <Link to="/new-audit">
                New Audit
              </Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<PieChartOutlined />}>
              <Link to="/audit-progress">
                Audit Progress
              </Link>
            </Menu.Item>
            <Menu.Item key="3" icon={<PieChartOutlined />}>
              <a href="https://vimeo.com/586861071" target="_blank">
                  Video Tutorial
              </a>
            </Menu.Item>
            <Menu.Item key="4" icon={<PieChartOutlined />}>
              <div onClick={logout}>
                Logout
              </div>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Content style={{ margin: '0 16px' }}>
            <div className="site-layout-background" style={{ padding: 24, margin: '16px 0', minHeight: 750 }}>
              {props.children}
            </div>
          </Content>
        </Layout>
      </Layout>
    );
}

export default MainView